// @flow
import { connect } from 'react-redux';

import CompetitionsInternationalesMatchsResults from 'components/competitionsInternationales/competitionsInternationalesMatchsResults';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/competitionsInternationales/competitionsInternationalesMatchsResults';

export default connect((state: StateType): StateProps => ({
  data: state.competitionsInternationalesState.data,
  status: state.competitionsInternationalesState.status
}))(CompetitionsInternationalesMatchsResults);
